module.exports = __webpack_public_path__ + "static/img/box.7fa8e345.jpg";